import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getUserInformation,
  getUserPermission,
  getUserRole,
} from "../../../../../store/userRole";
import {
  resetNavbarParams,
  setNavbarParams,
  setText,
} from "../../../../../store/navbar";
import {
  getMainScreenEndponts,
  getStudentEndPoints,
  MustIncludedSidebarItems,
} from "../../../../../constants/sidebar";
import { setLinks, showLinks } from "../../../../../store/sidebar";
import { extractModulesInMentionedOrder } from "../../../../../utils/validations";
import { getSingalClassroomData } from "../../../../../utils/classrooms";
import { permissionsParser } from "../../../../../utils/permissionsParser";

const useClassroomData = (classId, paramsClassId) => {
  const dispatch = useDispatch();
  const rolePermissions = useSelector(getUserPermission);
  const userInformation = useSelector(getUserInformation);
  const roleOfTheUser = useSelector(getUserRole);
  const [subjectList, setSubjectList] = useState([]);

  const classroomId = classId !== "" ? classId : paramsClassId;

  const [classroomLoader, setClassroomLoader] = useState(false);
  const [classroomName, setClassroomName] = useState("");
  const [classroomEndDate, setClassroomEndDate] = useState("");
  const [modules, setModules] = useState([]);
  const [createdBy, setCreatedBy] = useState("");
  const [classUsers, setClassUsers] = useState([]);

  // Get permissions for live classes
  const permissions = permissionsParser("Live Classes", rolePermissions);

  // Fetch classroom details
  const getClassroomDetails = async () => {
    try {
      setClassroomLoader(true);
      const response = await getSingalClassroomData(classroomId);
      if (response?.data?.classRoom) {
        if (response?.data?.classRoom?.name) {
          setClassroomName(response?.data?.classRoom?.name);
          setClassroomEndDate(response?.data?.classRoom?.endDate || "");
          setModules(response?.data?.classRoom?.modulesIncluded);
          setCreatedBy(response?.data?.classRoom?.createdBy);
          setSubjectList(
            response?.data?.classRoom?.course?.subjects?.map((subj) => ({
              id: subj?._id,
              label: subj?.name,
            }))
          );
          setClassUsers(response?.data?.classRoom?.team);
        }
      }
      setClassroomLoader(false);
    } catch (error) {
      console.error("Error fetching classrooms:", error.message);
      setClassroomLoader(false);
    }
  };

  // Set up navigation and sidebar
  useEffect(() => {
    if (classId === "") {
      const heading = "student-dashboard";
      dispatch(setText(heading));
      dispatch(setNavbarParams(`Live Classes & Recording | ${classroomName}`));
      const defaultItems = [
        ...getStudentEndPoints(
          classroomId,
          roleOfTheUser,
          createdBy === userInformation?._id,
          rolePermissions
        ),
      ];
      const sidebarItems = defaultItems.filter(
        (item) =>
          modules.includes(item?.value) ||
          MustIncludedSidebarItems.includes(item?.value)
      );
      const indOfItem = sidebarItems?.findIndex(
        (item) => item.value === "Live Classes"
      );
      if (indOfItem !== -1) {
        sidebarItems[indOfItem].selected = true;
      }
      dispatch(setLinks(extractModulesInMentionedOrder(sidebarItems, modules)));
      dispatch(showLinks());
    } else {
      const heading = "my-classrooms";
      dispatch(setText(heading));
      dispatch(resetNavbarParams());
      const mainEndpoints = getMainScreenEndponts(
        roleOfTheUser,
        rolePermissions
      );
      const indOfItem = mainEndpoints?.findIndex(
        (item) => item.value === "My Classrooms"
      );
      if (indOfItem !== -1) {
        mainEndpoints[indOfItem].selected = true;
      }
      dispatch(setLinks(mainEndpoints));
      dispatch(showLinks());
    }
  }, [
    classId,
    classroomId,
    classroomName,
    createdBy,
    dispatch,
    modules,
    roleOfTheUser,
    rolePermissions,
    userInformation?._id,
  ]);

  // Fetch classroom details on component mount
  useEffect(() => {
    getClassroomDetails();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    classroomId,
    classroomName,
    classroomEndDate,
    classroomLoader,
    permissions,
    createdBy,
    modules,
    userInformation,
    subjectList,
    classUsers,
  };
};

export default useClassroomData;
